import {service} from '@/api/config'

export default {

    // Career: {

        
    // }
}